/**
 * ErrorState
 * Centered error message container with urgent styling.
 */

import styled from '@emotion/styled';

export const ErrorState = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.space['2xl']};
  background: #fef2f2;
  border-radius: ${({ theme }) => theme.radius.regular};
  color: ${({ theme }) => theme.colors.semantic.urgent.color};
`;
